import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";

import {
  SiteConfig_siteConfig_tradingConf,
} from "graphql/generated";
import {
  Table,
  Tbody,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";

import { PredictionData } from "./types";

import PredictionHours from "./PredictionHours";
import RowsOfValues from "./RowsOfValues";
import RowsOfValuesMogador from "./RowsOfValuesMogador";
import ActivityIndicator from "components/activity-indicator";



interface IProps {
  tradingConf: SiteConfig_siteConfig_tradingConf;
  cellWidth?: number;
  cellPaddingX?: number;
  data: Record<string, any>;
}


const Prediction: FunctionComponent<IProps> = ({
  cellWidth = 35,
  cellPaddingX = 0,
  tradingConf,
  data,
}) => {
  const intl = useIntl();
  const prediction: PredictionData = data.prediction;
  const hoursColor = useColorModeValue("white", "gray.950");


  return (
    <>
      {prediction && <>
        <Table variant="unstyled" size="sm" mb={10}>
          <Thead>
            <Tr bg="enposol.500" color={hoursColor} position="sticky" top={0} zIndex={1}>
              <Th bg="enposol.500" position="sticky" left={0}>
                <ActivityIndicator data={prediction} position="absolute" left={0} top={0} />
                {intl.formatMessage({
                  id: "site__trading__hour",
                  defaultMessage: "Hour",
                })}
              </Th>
              <PredictionHours
                hours={prediction.hours}
                hour={prediction.hour}
                cellWidth={cellWidth}
                cellPaddingX={cellPaddingX}
              />
            </Tr>
          </Thead>
          <Tbody>
            {(tradingConf.uiVersion === "default" || tradingConf.uiVersion === "neufe") && <RowsOfValues data={data} />}
            {(tradingConf.uiVersion === "mogador") && <RowsOfValuesMogador data={data} />}
          </Tbody>
        </Table>
      </>}
    </>
  );
}

export default Prediction;
